import styled from 'styled-components';
import { gray4 } from '@styles/styled/variables';

export const ButtonsWrapper = styled.div`
  background: white;
  padding: 8px;
  text-align: right;
  display: flex;
  justify-content: space-between;

  button {
    margin: 0 8px;
    line-height: 1.2;
  }

  min-height: 45px;
`;

export const Wrapper = styled.div`
  padding: 8px;
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const PageTitle = styled.h1`
  position: absolute;
  left: 16px;
  font-size: 24px;
  top: 13px;
`;

export const StyledTabs = styled.div`
  display: flex;
  margin-bottom: 10px;

  a {
    text-decoration: none;
  }
`;

export const Shares = styled.div`
  margin-top: 16px;
  padding: 0 16px;
  white-space: normal;

  table {
    font-size: 16px;
    font-weight: 300;
    width: 100%;

    td,
    th {
      border-bottom: 1px solid ${gray4};
      padding: 8px 0;
    }

    th:nth-child(1),
    th:nth-child(2) {
      padding-right: 16px;
    }

    th:nth-child(2) {
      min-width: 140px;
    }
  }
`;

export const ActionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`;
